import React from "react";
import { useDispatch } from "react-redux";
import RouterComponent from "routes";
import { setUserInfo } from "store/slices/user";
import { useCookies } from "react-cookie";
import jwt_decode from "jwt-decode";
import js_config from "utils/config-variables";
import { createLDReactProvider } from "@launchdarkly/react-sdk";
import "./style.scss";

const loginCookie = window.env?.REACT_APP_LOGIN_COOKIE ?? "sl2sta_dev";

function App() {
  const dispatch = useDispatch();
  const [cookies] = useCookies([loginCookie]);
  const login_cookie = cookies[loginCookie];

  let userInfo = {};
  if (!login_cookie && location.pathname !== "/cookie") {
    window.location = `${window.env?.REACT_APP_LOGIN_URL ?? "/cookie"}?forwaredURL=${window.location.href}`;
  } else if (location.pathname !== "/cookie") {
    const loggedInUserInfo = jwt_decode(login_cookie);
    const expiry = new Date();
    expiry.setTime(expiry.getTime() + 24 * 60 * 60 * 1000);
    document.cookie = `user_email=${loggedInUserInfo.email}; expires=${expiry.toUTCString()}; path=/; secure`;
    const { admin_role, admin_label, executive_role, executive_label, guest_label } = js_config;
    let userType = guest_label;
    if (loggedInUserInfo?.roles && loggedInUserInfo.roles.includes(admin_role)) {
      userType = admin_label;
    } else if (loggedInUserInfo?.roles && loggedInUserInfo.roles.includes(executive_role)) {
      userType = executive_label;
    }

    userInfo = { ...loggedInUserInfo, userType, isExecutive: userType === js_config.executive_label };
    dispatch(setUserInfo(userInfo));
  }

  const LDProvider = createLDReactProvider(
    window?.env?.REACT_APP_FEATURE_FLAG_CLIENT_ID ?? "6a1dbd32dcc9a50a982891c8",
    { kind: "user", key: userInfo.email ?? "anonymous" },
  );

  return (
    <LDProvider>
      <RouterComponent />
    </LDProvider>
  );
}

export default App;
